(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-token-customizer]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const fields = [...root.querySelectorAll('[data-token-name]')];
    const previews = [...root.querySelectorAll('[data-token-preview]')];
    const mode = root.querySelector('[data-token-mode]');
    const shared = root.querySelector('[data-token-shared]');
    const individual = root.querySelector('[data-individual-fields]');
    let names = ['', '', '', ''];
    const savedKey = 'af-edco-token-backs';
    function render() {
      root.querySelector('[data-shared-field]').hidden = mode.value !== 'shared';
      individual.hidden = mode.value !== 'individual';
      fields.forEach((field, i) => {
        field.value = mode.value === 'shared' ? shared.value : mode.value === 'plain' ? '' : names[i];
        previews[i].textContent = field.value || previews[i].dataset.blank;
        previews[i].closest('[data-token-back]').classList.toggle('is-plain', !field.value);
      });
      root.querySelector('[data-token-layout]').value = mode.value === 'plain' ? 'Plain backs' : 'WE WERE HERE / name / EDCO 2026, blank names = plain';
      try { sessionStorage.setItem(savedKey, JSON.stringify({mode:mode.value,names,shared:shared.value})); } catch (_) {}
    }
    try {
      const saved = JSON.parse(sessionStorage.getItem(savedKey) || 'null');
      if (saved && ['individual', 'shared', 'plain'].includes(saved.mode) && Array.isArray(saved.names) && saved.names.length === 4) {
        mode.value = saved.mode; names = saved.names.map(x => String(x).slice(0,12)); shared.value = String(saved.shared || '').slice(0,12);
      }
    } catch (_) {}
    fields.forEach((field,i) => field.addEventListener('input', () => {names[i] = field.value; render();}));
    shared.addEventListener('input', render); mode.addEventListener('change', render);
    root.querySelector('[data-token-enhanced]').hidden = false;
    render();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
